import styled from "styled-components";

export const styledImage = styled.image`
  thing {
    object-fit: none;
    object-position: center;
    width: 100%;
    max-height: 250;
    margin-bottom: 1;
  }
`;
